export default "__VITE_ASSET__BVSNn9aA__"